{
  "version": "/../s3/3.0.0",
  "sentry_dsn": "",
  "deploy_url": "https://d2z8edzz48ni5t.cloudfront.net/appic-web-shop/3.0.0/"
}
